// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
import { path } from "../internal/utils/path.mjs";
export class AccessTokens extends APIResource {
    /**
     * Create a new client side access token with the specified configuration.
     */
    create(body, options) {
        return this._client.post('/v1/client-side-access-tokens', { body, ...options });
    }
    /**
     * List all client side access tokens for the current account. This is only
     * available for cloud users.
     */
    list(query = {}, options) {
        return this._client.get('/v1/client-side-access-tokens', { query, ...options });
    }
    /**
     * Delete a client side access token.
     */
    delete(token, params = undefined, options) {
        const { body } = params ?? {};
        return this._client.delete(path `/v1/client-side-access-tokens/${token}`, { body: body, ...options });
    }
}
//# sourceMappingURL=access-tokens.mjs.map